import React, { useState } from "react";
import { Box, Button, Typography, CircularProgress } from "@mui/material";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const MigrateMediaPage = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleMigrate = async () => {
    setLoading(true);
    setResult(null);
    try {
      const res = await axios.post(`${API_URL}/api/migrate-media/`);
      setResult(res.data);
    } catch (err) {
      console.error(err);
      setResult({ message: "Migration failed." });
    }
    setLoading(false);
  };

  return (
    <Box p={4}>
      <Typography variant="h4" mb={3}>
        Migrate Old Media to S3
      </Typography>
      <Button variant="contained" color="primary" onClick={handleMigrate} disabled={loading}>
        {loading ? <CircularProgress size={24} /> : "Start Migration"}
      </Button>

      {result && (
  <Box mt={4}>
    <Typography variant="h6">{result.message}</Typography>
    {result.skipped_files && result.skipped_files.length > 0 && (
      <Box mt={2}>
        <Typography color="error">Files Skipped / Failed:</Typography>
        <ul>
          {result.skipped_files.map((url, i) => (
            <li key={i}>{url}</li>
          ))}
        </ul>
      </Box>
    )}
  </Box>
)}

    </Box>
  );
};

export default MigrateMediaPage;
